import PropTypes from "prop-types";
import styles from "./index.css";
import { APP_SHORT_NAME } from "../../../constants";
import classnames from "classnames";

const Main = ({ children, className }) => (
  <main
    id={APP_SHORT_NAME}
    className={classnames(styles.main, className)}
    suppressHydrationWarning={true}
  >
    {children}
  </main>
);

Main.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

export default Main;
